<div
  *ngIf="gantryEvent()"
  class="gantry-event-container"
  class="cts-event-type cts-event-type--{{
    ctsGantryInitEventStatusService.translate(gantryEvent().type)
  }}"
>
  <div class="body-cts-event">
    <sh-icon
      icon="{{ ctsGantryInitEventStatusService.translate(gantryEvent().type) }}"
      size="s"
    ></sh-icon>
    <div>
      <div class="event-timestamp">
        <sh-text size="body-2">
          {{ dayMonth() | uppercase }} {{ hourMinute() }}
        </sh-text>
      </div>
      <sh-text class="event-description" color="secondary">
        {{
          ctsGantryInitEventStatusService.translate(gantryEvent().type) ===
            'error' && reducedLabel()
            ? ctsGantryInitEventStatusService.translateLabelReduced(
                gantryEvent().type
              )
            : ctsGantryInitEventStatusService.translateLabel(gantryEvent().type)
        }}
      </sh-text>
    </div>
  </div>
</div>
